export default defineNuxtPlugin((NuxtApp) => {
  const initCustomerio = () => {
    if (document.getElementById('cio-tracker')) return

    const siteId = NuxtApp.$env.customerio && NuxtApp.$env.customerio.siteId
    if (!siteId) return

    const region =
      (NuxtApp.$env.customerio && NuxtApp.$env.customerio.region) || 'us'
    const src =
      region === 'eu'
        ? 'https://assets.customer.io/assets/track-eu.js'
        : 'https://assets.customer.io/assets/track.js'

    window._cio = window._cio || []
    ;(function () {
      var cio = window._cio
      var a, b, c
      a = function (f) {
        return function () {
          cio.push([f].concat(Array.prototype.slice.call(arguments, 0)))
        }
      }
      b = ['load', 'identify', 'sidentify', 'track', 'page', 'on', 'off']
      for (c = 0; c < b.length; c++) {
        cio[b[c]] = a(b[c])
      }
      var t = document.createElement('script')
      var s = document.getElementsByTagName('script')[0]
      t.async = true
      t.id = 'cio-tracker'
      t.setAttribute('data-site-id', siteId)
      t.src = src
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        document.head.appendChild(t)
      }
    })()
  }

  const initSegment = () => {
    if (document.getElementById('segment')) return

    let script = document.createElement('script')
    let jsCode = `
          !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.13.1";
          analytics.load("${NuxtApp.$env.segment.writeKey}");
          // analytics.page();
          const event = new Event('segment_loaded');
          window.dispatchEvent(event);
          }}();`
    script.async = true
    script.id = 'segment'
    script.appendChild(document.createTextNode(jsCode))
    window.addEventListener(
      'segment_loaded',
      function (e) {
        NuxtApp.$store.dispatch('analytics/playBuffer')
      },
      false
    )
    document.head.appendChild(script)
  }

  const initAmplitude = () => {
    if (window.__amplitudeInitialized) return

    const apiKey = NuxtApp.$env.amplitude && NuxtApp.$env.amplitude.apiKey
    if (!apiKey) return

    const serverZone =
      NuxtApp.$env.amplitude && NuxtApp.$env.amplitude.serverZone === 'EU'
        ? 'EU'
        : 'US'

    window.__amplitudeInitialized = true
    import('@amplitude/analytics-browser')
      .then(({ init }) => {
        init(apiKey, {
          serverZone,
          autocapture: {
            pageViews: true,
            sessions: true,
            attribution: false,
            fileDownloads: false,
            formInteractions: false
          }
        })
      })
      .catch(() => {
        window.__amplitudeInitialized = false
      })
  }

  const initTracking = () => {
    if (process.client && NuxtApp.$env.env !== 'development') {
      console.log('installing 🍪 ...')
      var getGDPR = localStorage.getItem('GDPR:accepted')

      if (typeof getGDPR !== 'undefined' && getGDPR === 'true') {
        setTimeout(function () {
          initSegment()
          initCustomerio()
          initAmplitude()
        }, 0)
      }
    }
  }

  const initGaAnon = () => {
    if (process.client && NuxtApp.$env.env === 'development') {
      return
    }
    console.log('adding gtag anonyme...')
    // here add gtag anonymisé
    setTimeout(function () {
      let script = document.createElement('script')
      script.async = true
      script.id = 'ga-anonyme'
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-ZDQRDCK6XR'
      document.head.appendChild(script)
    }, 0)
    setTimeout(function () {
      let script = document.createElement('script')
      script.async = true
      script.id = 'ga-anonyme-2'
      let jsCode = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-ZDQRDCK6XR', { 'anonymize_ip': true });`
      script.appendChild(document.createTextNode(jsCode))
      document.head.appendChild(script)
    }, 0)
  }

  NuxtApp.$router.afterEach(function (to, from) {
    // console.log(to);
    // analytics page
    NuxtApp.$store.dispatch('analytics/page')
  })

  NuxtApp.$store.$initGaAnon = initGaAnon
  NuxtApp.$store.$initSegment = initSegment
  NuxtApp.$store.$initCustomerio = initCustomerio
  NuxtApp.$store.$initAmplitude = initAmplitude
  NuxtApp.$store.$initTracking = initTracking

  return {
    provide: {
      initGaAnon: initGaAnon,
      initSegment: initSegment,
      initCustomerio: initCustomerio,
      initAmplitude: initAmplitude,
      initTracking: initTracking
    }
  }
})
